<template>
  <div class="uc-like-container">
    <button
      :disabled="disable"
      class="uc-like-btn"
      :class="{liked: voted, action: clicked}"
      @click="send()"
    >
      <svg width="44px" height="44px" viewBox="0 0 44 40" xmlns="http://www.w3.org/2000/svg" class="like-indicator-svg">
        <g id="like" transform="translate(2,4)">
          <path class="like-indicator-clone" d="M19.8803976,6.35947826 C21.4948298,2.61626087 25.1829032,0.000782608696 29.4725886,0.000782608696 C35.2511037,0.000782608696 39.4127866,4.83652174 39.935997,10.5996522 C39.935997,10.5996522 40.2184026,12.0302609 39.5967902,14.6058261 C38.7503734,18.1134783 36.7607338,21.2298261 34.0782803,23.6081739 L19.8803976,36 L5.92171966,23.6073913 C3.23926624,21.2298261 1.24962663,18.1126957 0.403209771,14.6050435 C-0.218402607,12.0294783 0.0640030161,10.5988696 0.0640030161,10.5988696 C0.587213435,4.83573913 4.74889631,0 10.5274114,0 C14.8178968,0 18.2659655,2.61626087 19.8803976,6.35947826 Z" id="Path"></path>
          <path class="like-indicator" d="M19.8803976,6.35947826 C21.4948298,2.61626087 25.1829032,0.000782608696 29.4725886,0.000782608696 C35.2511037,0.000782608696 39.4127866,4.83652174 39.935997,10.5996522 C39.935997,10.5996522 40.2184026,12.0302609 39.5967902,14.6058261 C38.7503734,18.1134783 36.7607338,21.2298261 34.0782803,23.6081739 L19.8803976,36 L5.92171966,23.6073913 C3.23926624,21.2298261 1.24962663,18.1126957 0.403209771,14.6050435 C-0.218402607,12.0294783 0.0640030161,10.5988696 0.0640030161,10.5988696 C0.587213435,4.83573913 4.74889631,0 10.5274114,0 C14.8178968,0 18.2659655,2.61626087 19.8803976,6.35947826 Z" id="Path"></path>
        </g>
      </svg>
    </button>
    <div class="h2 ml-16">
      {{likes}}
    </div>
  </div>
</template>

<script>
import axios from "axios";

const BASE_URL = `${location.protocol}//${location.hostname}/api/like`;

export default {
  props: {
    token: Object,
    newId: String,
    actualLikes: String,
    actualVoted: Boolean
  },
  data() {
    return {
      likes: this.actualLikes,
      voted: this.actualVoted,
      disable: false,
      clicked: false
    };
  },
  computed: {
    getTokenObj: function() {
      var bodyFormData = new FormData();
      bodyFormData.set(this.token.name, this.token.value);
      return bodyFormData;
    }
  },
  methods: {
    send: async function() {
      try {
        this.clicked = !this.clicked;
        this.disable = true;
        let result = await axios.post(
          BASE_URL + `?newId=${this.newId}`,
          this.getTokenObj
        );
        this.likes = result.data.likes;
        if (result.data.action === "like") {
          this.voted = true;
        }
        if (result.data.action === "unlike") {
          this.voted = false;
          this.clicked = false;
        }
        this.disable = false;
      } catch (error) {
        this.clicked = false;
        this.disable = true;
      }
    }
  }
};
</script>
